import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import authenService from "../services/authenService";
import constants from "../constants";
import h from "../services/h";
// import vbNotificationService from "../services/vbNotificationService";
import dashBoardService from "../services/dashBoardService";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  // strict: debug,
  state: {
    user: null,
    userDeptRoles: null,
    userDeptRoleId: null,
    notificationsUnreadCount: 0,
    notifies: [],
    pageable: {
      page: 0,
      size: 50,
      sort: "createTime,desc",
    },
    calendarStatusFilter: null,
    enableMenuCodes: [],
  },
  mutations: {
    setCalendarStatusFilter(state, data) {
      state.calendarStatusFilter = data;
    },

    setNameRoute(state, payload) {
      state.nameRoute = payload;
    },

    loadMore(state, data) {
      state.notifies = state.notifies.concat(data);
    },

    login(state, loginData) {
      state.user = loginData.user;
      state.userDeptRoles = loginData.userDeptRoles;
    },

    changeAvatar(state, data) {
      state.user = { ...state.user, iconPhoto: data.iconPhoto, avatar: data.avatar }
    },

    changeProfile(state, data) {
      state.user = { ...state.user, ...data };
    },

    updateSeenNotifi(state, data) {
      dashBoardService.getNotificationsDashBoard(state.pageable).then(response => {
        state.notifies = response.data.notis;
        state.notificationsUnreadCount = response.data.countNotiUnreads;
      });
      /* vbNotificationService.countUnSeen()
        .then(response => {
          state.notificationsUnreadCount = response.data;
        }) */
    },

    updateNotifies(state, data) {
      state.notifies = data.notis;
      state.notificationsUnreadCount = data.countNotiUnreads;
    },

    changeUserDeptRole(state, userDeptRoleId) {
      state.userDeptRoleId = userDeptRoleId;
      authenService.store(
        constants.STORAGE_KEY.USER_DEPT_ROLE_ID,
        state.userDeptRoleId
      );
      /* dashBoardService.getNotificationsDashBoard(state.pageable).then(response => {
        state.notifies = response.data.notis;
        state.notificationsUnreadCount = response.data.unreadDocsCount;
      }); */
      /* vbNotificationService.countUnSeen()
        .then(response => {
          state.notificationsUnreadCount = response.data;
        }) */

      //load thong tin notify;
    },

    refreshNoti(state) {
      /* vbNotificationService.findAll(state.pageable).then(response => {
        state.notifies = response.data;
      }); */
      dashBoardService.getNotificationsDashBoard(state.pageable).then(response => {
        state.notifies = response.data.notis;
        state.notificationsUnreadCount = response.data.countNotiUnreads;
      });
    },

    subCount(state) {
      state.notificationsUnreadCount -= 1;
    },

    startLoading(state) {
      state.isLoadingFlag++;
    },

    stopLoading(state) {
      state.isLoadingFlag--;
    },

    setFullScreen(state) {
      state.fullScreen = true;
    },
    setHalfScreen(state) {
      state.fullScreen = false;
    },
    setEnableMenuCodes(state, data) {
      state.enableMenuCodes = data;
    }
  },
  actions: {},
  getters: {
    userDeptRoles: state => state.userDeptRoles,
    user: state => state.user,
    notificationsUnreadCount: state => state.notificationsUnreadCount,
    userDeptRoleId: state => state.userDeptRoleId,
    userDeptRole: state => {
      return h.find(
        state.userDeptRoles,
        userDeptRole => userDeptRole.id === state.userDeptRoleId
      );
    },
    notifies: state => state.notifies,
    calendarStatusFilter: state => state.calendarStatusFilter,
    enableMenuCodes: state => state.enableMenuCodes,
  },
  plugins: debug ? [createLogger()] : []
});



// WEBPACK FOOTER //
// ./src/store/index.js